import { Loader } from '@googlemaps/js-api-loader';
import { config } from './config';

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
  }
  return {
    loader: new Loader({
      apiKey: config.apiKey,
      libraries: ['places'],
      version: 'weekly',
    }),
  };
})();
